import { render } from "./IconsForm.vue?vue&type=template&id=53203c46&scoped=true"
import script from "./IconsForm.vue?vue&type=script&lang=js"
export * from "./IconsForm.vue?vue&type=script&lang=js"

import "./IconsForm.vue?vue&type=style&index=0&id=53203c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.35_vue@3.4.35_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53203c46"]])

export default __exports__